import { getApplicationKeepAliveApi, getSessionTimeout } from "../api/idleSession";


export const sessionTimeout = async () => {
  try {
    const response = await getSessionTimeout();
    if (!response) {
      throw new Error("Invalid response structure");
    }
    return response;
  } catch (error) {
    console.error("Unexpected error in sessionTimeout:", error.message);
    return null;
  }
}


export const keepAlive = async () => {
    try {
      const response = await getApplicationKeepAliveApi();
      if (!response) {
        throw new Error("Invalid response structure");
      }
      return response;
    } catch (error) {
      console.error("Unexpected error in keepAlive:", error.message);
      return null;
    }
  }